import {WebView as WebViewType} from 'react-native-webview';
import {useNavigation} from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {useRef} from 'react';
import WebviewJSBridge, {messageBodyType} from '../utils/webviewJSBridge';
import {injectJavaScriptText} from '../utils/webviewJSBridge/browser';

export default function useWebviewJSEventBus() {
  const webviewRef = useRef<WebViewType | null>(null);
  const navigation = useNavigation();
  const eventHandle = (
    event: string,
    data: messageBodyType,
    res: (data: string) => void,
  ): void => {
    if (event.startsWith('route')) {
      switch (event) {
        case 'routeGoBack': {
          navigation.goBack();
          break;
        }
        case 'routeNavigate': {
          // @ts-ignore
          navigation.navigate(data.routeName, data.params);
          break;
        }
        case 'routeLogin': {
          // @ts-ignore
          navigation.replace('Login');
          break;
        }
        case 'routeReload': {
          // @ts-ignore
          navigation.reload();
        }
      }
    } else if (event.startsWith('storage')) {
      switch (event) {
        case 'storageSave': {
          try {
            // @ts-ignore
            if (data && data.value) {
              // @ts-ignore
              AsyncStorage.setItem(data.key, data.value);
            }
            break;
          } catch (e) {
            // saving error
          }
          break;
        }
        case 'storageGet': {
          try {
            AsyncStorage.getItem(data as string).then(v => {
              res(v || '');
              // @ts-ignore
              // webviewRef.current.postMessage(`storageGetRes:!${v}`);
            });
          } catch (e) {
            // saving error
          }
          break;
        }
      }
    } else if (event.startsWith('utils')) {
      switch (event) {
        case 'utilsImageView': {
          break;
        }
      }
    }
  };
  const jSBridge = new WebviewJSBridge([eventHandle], webviewRef);

  return {
    jSBridge,
    onWebMessage: jSBridge.onMessage,
    webviewRef,
    injectJavaScriptText,
  };
}
